<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>New Custom Template</h4>
    <button mat-button [mat-dialog-close]="" (click)="close()" cdkFocusInitial>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content [formGroup]="myGroup" class="dialog-content">
    <mat-form-field class="full-width" mat-focused>
      <mat-label>Template Name: </mat-label>
      <input matInput formControlName="templateControl" cdkFocusInitial />
    </mat-form-field>
    <mat-checkbox
      [(ngModel)]="shareCheckbox"
      [ngModelOptions]="{standalone: true}"
      class="full-width"
      >Do Not Share With Company</mat-checkbox
    >
    <mat-checkbox
      [(ngModel)]="activeCheckbox"
      [ngModelOptions]="{standalone: true}"
      class="full-width"
      >Make this your Active Template</mat-checkbox
    >
  </div>
  <div mat-dialog-actions class="right-end">
    <button
      mat-button
      (click)="onNewTemplate()"
      class="button-close"
      cdkFocusInitial
    >
      Save
    </button>
    <button mat-button (click)="close()" mat-dialog-close class="button-close">
      Cancel
    </button>
  </div>
</div>
